module.exports = __webpack_public_path__ + "img/54.6fbda6e2.jpg";